// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.img {
  width: 200px;
  border-radius: 5px;
  cursor: zoom-in;
  display: block;
  border: 2px solid black; /* Added black border */
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.img:hover {
  transform: scale(1.05); /* Slight zoom effect on hover */
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3); /* Shadow on hover */
}

.img-panel {
  padding: 5px;
  background-color: transparent;
  height: auto;
  width: auto;
  display: inline-block;
  transition: all 200ms ease;
  border-radius: 5px;
}

.img-panel:hover {
  background-color: #20A4F3;
}

.img-panel__selct {
  background-color: #20A4F3;
}

.display-box {
  padding: 1em;
  max-width: 1000px;
  min-width: 300px;
  margin: 1em auto;
  display: grid;
  grid-gap: 1em;
  grid-template-columns: repeat(auto-fill, 210px);
  grid-auto-flow: row;
  justify-content: center;
}

.img-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: transparent;
  transition: all 200ms ease;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99999999;
}

.img-wrapper__initial {
  background-color: rgba(0, 0, 0, 0.7);
}

.image__selected {
  max-width: 70vw;
  max-height: 80vh;
  display: block;
  cursor: pointer;
  transition: all 300ms ease-in-out;
  position: relative;
  border: black solid 4px; /* Black border for the enlarged image */
  border-radius: 5px;
}

.img-selected-initial {
  border: white solid 4px;
}

.img-close {
  height: 50px;
  width: 50px;
  position: absolute;
  top: 1.5em;
  left: 1.5em;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: all 200ms ease-in-out;
  cursor: pointer;
  border-radius: 5px;
}

.img-close:hover {
  background-color: #CA3B4E;
}

.img-close:before {
  content: " ";
  height: 40px;
  width: 5px;
  background-color: white;
  transform: rotate(45deg);
  position: absolute;
  cursor: pointer;
}

.img-close:after {
  content: " ";
  height: 40px;
  width: 5px;
  transform: rotate(135deg);
  position: absolute;
  z-index: 100;
  background-color: white;
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/app/components/transaction/imageview.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,uBAAuB,EAAE,uBAAuB;EAChD,qDAAqD;AACvD;;AAEA;EACE,sBAAsB,EAAE,gCAAgC;EACxD,wCAAwC,EAAE,oBAAoB;AAChE;;AAEA;EACE,YAAY;EACZ,6BAA6B;EAC7B,YAAY;EACZ,WAAW;EACX,qBAAqB;EACrB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,aAAa;EACb,+CAA+C;EAC/C,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,6BAA6B;EAC7B,0BAA0B;EAC1B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,iCAAiC;EACjC,kBAAkB;EAClB,uBAAuB,EAAE,wCAAwC;EACjE,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iCAAiC;EACjC,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,UAAU;EACV,uBAAuB;EACvB,wBAAwB;EACxB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,UAAU;EACV,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;EACvB,eAAe;AACjB","sourcesContent":[".img {\n  width: 200px;\n  border-radius: 5px;\n  cursor: zoom-in;\n  display: block;\n  border: 2px solid black; /* Added black border */\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\n}\n\n.img:hover {\n  transform: scale(1.05); /* Slight zoom effect on hover */\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3); /* Shadow on hover */\n}\n\n.img-panel {\n  padding: 5px;\n  background-color: transparent;\n  height: auto;\n  width: auto;\n  display: inline-block;\n  transition: all 200ms ease;\n  border-radius: 5px;\n}\n\n.img-panel:hover {\n  background-color: #20A4F3;\n}\n\n.img-panel__selct {\n  background-color: #20A4F3;\n}\n\n.display-box {\n  padding: 1em;\n  max-width: 1000px;\n  min-width: 300px;\n  margin: 1em auto;\n  display: grid;\n  grid-gap: 1em;\n  grid-template-columns: repeat(auto-fill, 210px);\n  grid-auto-flow: row;\n  justify-content: center;\n}\n\n.img-wrapper {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: transparent;\n  transition: all 200ms ease;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 99999999;\n}\n\n.img-wrapper__initial {\n  background-color: rgba(0, 0, 0, 0.7);\n}\n\n.image__selected {\n  max-width: 70vw;\n  max-height: 80vh;\n  display: block;\n  cursor: pointer;\n  transition: all 300ms ease-in-out;\n  position: relative;\n  border: black solid 4px; /* Black border for the enlarged image */\n  border-radius: 5px;\n}\n\n.img-selected-initial {\n  border: white solid 4px;\n}\n\n.img-close {\n  height: 50px;\n  width: 50px;\n  position: absolute;\n  top: 1.5em;\n  left: 1.5em;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  transition: all 200ms ease-in-out;\n  cursor: pointer;\n  border-radius: 5px;\n}\n\n.img-close:hover {\n  background-color: #CA3B4E;\n}\n\n.img-close:before {\n  content: \" \";\n  height: 40px;\n  width: 5px;\n  background-color: white;\n  transform: rotate(45deg);\n  position: absolute;\n  cursor: pointer;\n}\n\n.img-close:after {\n  content: \" \";\n  height: 40px;\n  width: 5px;\n  transform: rotate(135deg);\n  position: absolute;\n  z-index: 100;\n  background-color: white;\n  cursor: pointer;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
